var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('img',{staticClass:"top__logo",attrs:{"src":require('@/assets/img/svg/logo_top.svg')}}),_c('div',{staticClass:"top__title"},[_vm._v(" "+_vm._s(_vm.$t('header.title'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }